/**
 * Get current path number.
 *
 * @param {string[]} path Path names.
 * @param {RegExp} pathNameRegex Path name Regex.
 *
 * @returns {number} Current path number.
 */
export function getCurrentPathNumber(path: string[], pathNameRegex: RegExp): number {
  let current = 0;
  if (path.length) {
    current = Math.max(
      ...path.map((name) => {
        const match = pathNameRegex.exec(name);
        if (!match) {
          return 0;
        }

        const number = Number(match[1]);
        return Number.isNaN(number) ? 0 : number;
      }),
    );
  }

  return current;
}
